<template>
    <div>
        <div class="small">
            <span v-html="label" />
            <ob1-liens
                v-if="popin4xCb"
                :text="popin4xCb.text"
                :is-button="true"
                :modal-id="'legal-mentions-popin-4xcb'"
            />
        </div>
        <pxf-cb4x-modal
            v-if="popin4xCb"
            modal-id="legal-mentions-popin-4xcb"
            :display-cb4x="true"
            :display-pxf="false"
        >
            <template #cb4x-content>
                <cb4x-modal-content
                    :header-block="popin4xCb.headerBlock"
                    :payment-example-block="popin4xCb.paymentExampleBlock"
                    :payment-simulation-block="popin4xCb.paymentSimulationBlock"
                    :how-to-benefit="popin4xCb.howToBenefit"
                    :faq="popin4xCb.faqBlock"
                    :cgu="popin4xCb.cgu"
                    :monthly-price="popin4xCb.monthlyPrice"
                    :first-monthly-price="popin4xCb.firstMonthlyPrice"
                    :one-shot-price="popin4xCb.oneShotPrice"
                    :tms="popin4xCb && popin4xCb.tms ? popin4xCb.tms : {}"
                    :illustration="popin4xCb.imageZen"
                />
            </template>
        </pxf-cb4x-modal>
    </div>
</template>

<script>
import pxfCb4xModal from "./PxfCb4xModal.vue";
import Cb4xModalContent from "./Cb4xModalContent.vue";

export default {
    name: "LegalMentions4xCb",
    components: {
        Cb4xModalContent,
        pxfCb4xModal
    },
    props: {
        label: {
            type: String,
            required: true
        },
        popin4xCb: {
            type: Object,
            default: null,
            required: false
        }
    }
}
</script>
